export const NV_METRICS_CATEGORY = 'nvMetrics'
export const LOTS_METRICS_CATEGORY = 'lotsMetrics'
export const FTD_METRICS_CATEGORY = 'ftdMetrics'
export const DEPOSITS_METRICS_CATEGORY = 'depositsMetrics'
export const NET_DEPOSITS_METRICS_CATEGORY = 'netDepositsMetrics'
export const NEW_CLIENTS_METRICS_CATEGORY = 'newClientsMetrics'
export const ACTIVE_CLIENTS_METRICS_CATEGORY = 'activeClientsMetrics'
export const OPENED_TA_METRICS_CATEGORY = 'openedTAMetrics'
export const ACTIVE_TA_METRICS_CATEGORY = 'activeTAMetrics'
export const IB_COMMISSIONS_METRICS_CATEGORY = 'ibCommissionsMetrics'
